import { useEffect, useState } from 'react'

import { Api } from 'contexts/api';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import { setProfileLocal } from "utils/components";
import { useAuth } from 'contexts/useAuth';
import { useHistory } from 'react-router-dom';

const LoginOne = props => {

  const auth = useAuth()
  const franchises = auth.user
  const history = useHistory()
  const [loading, setLoading] = useState(false)

  const rememberMe = () => {

  }

  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 150)
  }, [])

  const hasProfiles = auth.user.length > 1 || franchises[0]?.roles?.length > 1

  const loginForm = (
    (!auth.user && !auth.profile) ? (
      <StepOne {...props} rememberMe={rememberMe} loading={loading} />
    ) : (<StepTwo franchises={auth.user} loading={!hasProfiles} />)

  )

  return (
    <>
      {loginForm}
    </>
  )
}

export default LoginOne
